import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "segment" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "count"
}
const _hoisted_5 = {
  key: 0,
  class: "state"
}
const _hoisted_6 = {
  key: 1,
  class: "state"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "muted" }
const _hoisted_9 = { class: "move" }
const _hoisted_10 = { class: "muted" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "muted" }
const _hoisted_13 = { class: "muted" }
const _hoisted_14 = {
  key: 0,
  class: "muted"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "btns"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "btns"
}
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Lead Transfers", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.load
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: t.key,
                  class: _normalizeClass({ on: _ctx.tab === t.key }),
                  onClick: ($event: any) => (_ctx.tab = t.key)
                }, [
                  _createTextVNode(_toDisplayString(t.label), 1),
                  (t.count)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(t.count), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_3))
              }), 128))
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ion_spinner, { name: "crescent" })
                ]))
              : (!_ctx.current.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.emptyText), 1))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current, (t) => {
              return (_openBlock(), _createElementBlock("div", {
                key: t.id,
                class: "item"
              }, [
                _createElementVNode("div", {
                  class: "item-top",
                  onClick: ($event: any) => (_ctx.$router.push('/sales-leads/' + t.sales_lead_id))
                }, [
                  _createElementVNode("b", null, _toDisplayString(t.lead ? t.lead.company_name : 'Lead'), 1),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(t.lead ? t.lead.lead_code : '') + " ›", 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status", 'st-' + t.status.toLowerCase()])
                  }, _toDisplayString(t.status), 3)
                ], 8, _hoisted_7),
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.name(t.from_user)) + " → ", 1),
                  _createElementVNode("b", null, _toDisplayString(_ctx.name(t.to_user)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(t.reason), 1),
                  (t.note)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, ": " + _toDisplayString(t.note), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, "Requested by " + _toDisplayString(_ctx.name(t.requested_by)) + " · " + _toDisplayString(_ctx.format(t.created_at)), 1),
                _createElementVNode("div", _hoisted_13, "Approver: " + _toDisplayString(t.approver ? t.approver.name : 'Sales head / admin'), 1),
                (t.responded_at)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(t.status) + " by " + _toDisplayString(_ctx.name(t.responded_by)) + " · " + _toDisplayString(_ctx.format(t.responded_at)), 1),
                      (t.response_note)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, " — " + _toDisplayString(t.response_note), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'approve')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "bad",
                        onClick: ($event: any) => (_ctx.decide(t, 'reject'))
                      }, "Reject", 8, _hoisted_17),
                      _createElementVNode("button", {
                        class: "ok",
                        onClick: ($event: any) => (_ctx.decide(t, 'approve'))
                      }, "Approve", 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'sent' && t.status === 'Pending')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.cancel(t))
                      }, "Cancel request", 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}